export const CmsSymbols = {
    DataProvider: Symbol.for("WpCmsDataProvider"),
    CmsService: Symbol.for("WpCmsService")
}